import { Size, TextIconColor } from '../constants';
import { Icon } from '../Icon/Icon.consts';
import Icons from '../Icon/Icons';
import ToolTip from '../ToolTip/ToolTip';
import Typography from '../Typography/Typography';
import {
  TypographyFont,
  TypographySize,
  TypographyWeight,
  TypographyWrap
} from '../Typography/Typography.consts';

import { ChipSize, chipStyles } from './Chip.styles';

interface ChipProps {
  label: string;
  onClick?: () => void;
  onClose?: () => void;
  size?: ChipSize;
  startIcon?: Icon;
  tooltip?: string;
}

export const Chip = ({
  label,
  onClick,
  onClose,
  size = Size.SMALL,
  startIcon,
  tooltip
}: ChipProps) => {
  const chipClasses = chipStyles({
    size,
    hasClose: !!onClose
  });

  return (
    <ToolTip content={tooltip}>
      <div
        className={chipClasses}
        data-testid="chip-container"
        onClick={onClick}
      >
        {startIcon && (
          <div
            className="-mr-[3px] flex h-4 w-4 items-center justify-center"
            data-testid="chip-icon-container"
          >
            <Icons color={TextIconColor.PRIMARY} icon={startIcon} />
          </div>
        )}
        <Typography
          color={TextIconColor.PRIMARY}
          font={TypographyFont.PARAGRAPH}
          size={TypographySize.X_SMALL}
          weight={TypographyWeight.MEDIUM}
          wrap={TypographyWrap.NO_WRAP}
        >
          {label}
        </Typography>
        {onClose && (
          <button
            className="flex h-3.5 w-3.5 items-center justify-center rounded-sm bg-white/30 p-[1px] transition-all duration-200 hover:bg-white/40"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            <Icons color={TextIconColor.PRIMARY} icon={Icon.CLOSE} />
          </button>
        )}
      </div>
    </ToolTip>
  );
};

export default Chip;
